import React, { useEffect, useRef } from "react";
import { useState } from "react";
import "./index.css";
import { Form, FormGroup, Table } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { Formik } from "formik";
import SvgImage from "../../../Icons/Icons";
import { DatePickerField } from "../../../core/inputs/input";
import moment from "moment";
import { Button } from "reactstrap";
import Switch from "react-switch";
import { getSignedUrlApiAction, storeMedia, toastStatus } from "../../../../services/Store/Actions/appActions";
import ImageModal from "../../imageModal";
import { saveVehicleProfileData, getVehicleProfileData } from "../../../../services/Store/Actions/fleetActions";
import { ClipLoader } from "react-spinners";
import { toast } from "react-toastify";

function DocumentItems(props) {
    const dispatch = useDispatch();

    const { type,value ,data, fleetId, vehicleData} = props
    console.log("keyvaluedata DocumentItems",type, value ,data, vehicleData);
    const [update, setUpdate] = useState(false);
    const [imageLoader, setImageLoader] = useState(false);
    const [displayName, setDisplayName] = useState(false);
    
    const closeUpdate = () => {
        setUpdate(false);
    };
    const toggleUpdate = () => {
        setUpdate(!update);
    }
    const [imageModal, setImageModal] = useState(false);
    const closeImageModal = () => {
        setImageModal(false);
    };
    const toggleImageModal = () => {
        setImageModal(!imageModal);
    }
    const [uploadStatus, setUploadStatus] = useState(false);
    const closeUploadStatus = () => {
        setUploadStatus(false);
    };
    const toggleUploadDoc = () => {
        setUploadStatus(!uploadStatus);
    }
    
    const [create, setCreate] = useState(data?.VehicleProfileId? false : true);
    const [imageUrl, setImageUrl] = useState('');
    const [rawImage, setRawImage] = useState(data?.imageUrl || '')
    const [isUpload, setIsUpload] = useState(false);
    const documentId = "DocumentItemPage"
    const notify =  (msg, isError = false) => {
        console.log("ajshgvdkba");
        if(isError){
            toast.error(msg || "failed", {
                toastId: documentId,
            })
        }else{
            toast.success(msg || "success", {
                toastId: documentId,
            })
        }
       
    }
    useEffect(() => {
        if(rawImage && !imageUrl){
            dispatch(
                getSignedUrlApiAction(
                  { key: rawImage},
                  (res) => {
                    // setDownloadLoader2(false);
                    // setLoaderInvoiceId("");
                    if (res.status == 200) {
                        console.log("getSignedUrlApiAction",value,res?.data?.data);
                        setImageUrl(res?.data?.data)
                    }
                  }
                )
              );
        }
    },[rawImage])
    const printDocument = () => {
        window.open(imageUrl)
    }
    const boxShadow = (type, date) => {
        let a = { }
        if((type == 102 || type == 103 )&& (Date.parse(date) - Date.now() < 15*24*60*60*1000) ){
            a.boxShadow = "0 2px 4px 0 rgb(255, 0, 0,1), 0 1.5px 5px 0 rgba(255, 0, 0, 0.98)" 
        }else if((type == 102 || type == 103 ) && (Date.parse(date) - Date.now() < 30*24*60*60*1000)){
            a.boxShadow = "0 2px 4px 0 rgb(255, 150, 0,1), 0 1.5px 5px 0 rgba(255, 150, 0, 0.98)" 
        }else{
            a.boxShadow = "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)" 
        }
        return a 
    }
    
    const expDate = type == 102 ? vehicleData?.insuranceUpto: type== 103 ? vehicleData?.pucExpiryDate: type== 104 ? vehicleData?.permitUpto: type== 105 ? vehicleData?.roadTaxUpto: type== 106 ? vehicleData?.fitnessUpto: ""

    const styleTemp = boxShadow(type, expDate);
    return  (<div>
            <div className="divClass1 imageBox" style={{height: ["101","102","103"].includes(type) ? "300px" : "200px", ...styleTemp }}>
                <div className="col-8" style={{ width: "50%",paddingTop: "20px"}}>
                    <div style={{display: "flex", flexDirection:"row", justifyContent:"space-between"}}>
                    <div className=" heading2 semiBold">
                        {value}
                    </div>
                    <div className="divClass1" style={{ justifyContent: "end" }} >
                    {imageUrl ? <div onClick={printDocument} style={{ paddingRight: "5px" }}>
                                <SvgImage name="downloadImg" width="24" height="24" />
                            </div>: <></>}
                       { imageUrl ? <div 
                            onClick={() =>  {
                                setIsUpload(!isUpload)
                                setUploadStatus(false)
                                }}
                            style={{ paddingLeft: "5px" }} >
                            <SvgImage name="editLogo" width="25" height="25" />
                        </div>: <></>}
                    </div>
                </div>
                    { type==101 ? (<div style={{marginTop:"50px"}}>
                        <div className="divClass1">
                            <div>RC Number</div><div>{vehicleData.registrationNumber}</div>
                        </div>
                        <div className="divClass1">
                            <div>Chassis Number</div><div>{vehicleData.chassisNumber}</div>
                        </div>
                        <div className="divClass1">
                            <div>registration Date</div><div>{vehicleData.registrationDate}</div>
                        </div>
                        <div className="divClass1">
                            <div>Engine Number</div><div>{vehicleData.engineNumber}</div>
                        </div>
                        <div className="divClass1">
                            <div>Owner Name</div><div>{vehicleData.ownerName}</div>
                        </div>
                        <div className="divClass1">
                            <div>Registered At</div><div>{vehicleData.registeredAt}</div>
                        </div>
                        
                    </div>): type==102 ? (<div style={{marginTop:"50px"}}>
                        <div className="divClass1">
                            <div>Insurer</div><div>{vehicleData.insuranceCompany}</div>
                        </div>
                        <div className="divClass1">
                            <div>Policy Number</div><div>{vehicleData.insurancePolicyNumber}</div>
                        </div>
                        <div className="divClass1">
                            <div>Expiry Date</div><div>{vehicleData.insuranceUpto}</div>
                        </div>
                        <div className="divClass1">
                            <div>Maker</div><div>{vehicleData.makerDescription}</div>
                        </div>
                        <div className="divClass1">
                            <div>Model</div><div>{vehicleData.makerModel}</div>
                        </div>
                        <div className="divClass1">
                            <div>Vehicle Class</div><div>{vehicleData.vehicleClassDescription}</div>
                        </div>
                    </div>): type ==103 ? (
                        <div style={{marginTop:"50px"}}>
                        <div className="divClass1">
                            <div>PUC Number</div><div>{vehicleData.pucNumber}</div>
                        </div>
                        <div className="divClass1">
                            <div>Expiry Date</div><div>{vehicleData.pucExpiryDate}</div>
                        </div>
                        <div className="divClass1">
                            <div>Fuel Type</div><div>{vehicleData.fuelDescription}</div>
                        </div>
                        <div className="divClass1">
                            <div>Norms</div><div>{vehicleData.normsDescription}</div>
                        </div>
                    </div>
                    ):type ==104 ? (
                        <div style={{marginTop:"50px"}}>
                        <div className="divClass1">
                            <div>Permit Number</div><div>{vehicleData.permitNumber}</div>
                        </div>
                        <div className="divClass1">
                            <div>Expiry Date</div><div>{vehicleData.permitUpto}</div>
                        </div>
                        <div className="divClass1">
                            <div>Registration Date</div><div>{""}</div>
                        </div>
                    </div>
                    ): type ==105 ? (
                        <div style={{marginTop:"50px"}}>
                        <div className="divClass1">
                            <div>Document Number</div><div>{""}</div>
                        </div>
                        <div className="divClass1">
                            <div>Expiry Date</div><div>{vehicleData.roadTaxUpto}</div>
                        </div>
                        <div className="divClass1">
                            <div>Registration Date</div><div>{""}</div>
                        </div>
                    </div>
                    ):type ==106 ? (
                        <div style={{marginTop:"50px"}}>
                        <div className="divClass1">
                            <div>Document Number</div><div>{""}</div>
                        </div>
                        <div className="divClass1">
                            <div>Expiry Date</div><div>{vehicleData.fitnessUpto}</div>
                        </div>
                        <div className="divClass1">
                            <div>Registration Date</div><div>{""}</div>
                        </div>
                    </div>
                    ):<></>}
                </div>
                <div className="col-4 " style={{
                }}>{imageUrl && !isUpload ? ( 
                <div className="documentBox" style={{height:["101","102","103"].includes(type) ? "285":"185px" }} onClick={()=>{ 
                    if(!imageUrl.includes(".pdf")){ setImageModal(true) }
                    else { window.open(imageUrl)}}}>
                    <img 
                        src={imageUrl.split('?')[0]}
                        alt={imageUrl.includes(".pdf") ? value+".pdf" : value}
                        width="100%" 
                    />
                </div>):(
                <div  style={{margin: "auto", width: "50%",height: "140px",marginTop: ["101","102","103"].includes(type) ? "80px": "30px", border: "1px solid "}}> 
                    <Formik
                    // isValid='true'
                    enableReinitialize
                    initialValues={{
                        fleetId: fleetId ? fleetId : "",
                        docUrl: null,
                    }}
                    onSubmit={(values) => {
                        let objVal = {
                            fleetId: fleetId ? fleetId : "",
                            expenseType: type,
                            imageUrl: values?.docUrl,
                        };
                        dispatch(
                            saveVehicleProfileData(objVal, (res) => {
                            if (res?.status == 200) {
                                setRawImage(values?.docUrl)
                                dispatch(getVehicleProfileData({fleetId: fleetId}, (res)=> {
                                    console.log("dispatchgetVehicleProfileData", res);
                                    if(imageUrl) setIsUpload(false)
                                }));
                                notify("document uploaded successFully");
                            } else if (res?.status == 201) {
                                notify("document upload failed", true);
                            }
                        })
                        );
                    }}
                    >
                    {({
                        handleBlur,
                        handleChange,
                        handleSubmit,
                        setFieldValue,
                        resetForm,
                        values,
                        touched,
                        isValid,
                        errors,
                    }) => (
                        <Form
                        onSubmit={handleSubmit}
                        style={{ padding: "0 50px 0 50px" }}
                        >
                        <div>

                        <FormGroup style={{ marginRight: "110px" }}>
                            <div style={{ display: "flex" }}>
                                {!uploadStatus ? (
                                <p
                                    className="heading4 Regular"
                                    style={{ margin: "10px 0 5px" }}
                                >
                                    Upload Document
                                </p>
                                ) : (
                                <></>
                                )}
                                {!uploadStatus ? (
                                <Button
                                    className="add-attach-for-fastag-linked-vehicle-new"
                                    type="button"
                                >
                                    {imageLoader ? (
                                    <div style={{ zIndex: 10 }}>
                                        <ClipLoader
                                        color={"#2E7C7B"}
                                        loading={true}
                                        size={20}
                                        aria-label="Loading Spinner"
                                        data-testid="loader"
                                        />
                                    </div>
                                    ) : (
                                    <div>
                                        <SvgImage
                                        name="AddAttachment"
                                        height="25"
                                        width="25"
                                        />
                                        <input
                                        type="file"
                                        style={{ width: "25px" }}
                                        // multiple
                                        // accept="image/*"
                                        accept="image/*, application/pdf"
                                        className="add-lr-attachment"
                                        onChange={(e) => {
                                            const img = e?.target.files[0];
                                            console.log("image", img?.name);

                                            const tempArray = Object.assign(
                                            [],
                                            values.docs
                                            );
                                            console.log("sel", tempArray);

                                            if (img == null) {
                                            //clear image
                                            setFieldValue("docUrl", "", true);
                                            //for now  only one supported
                                            } else {
                                            console.log("upload", {
                                                img: img,
                                                uploadType: "aadharFront",
                                                isRes: true,
                                            });
                                            setImageLoader(true);
                                            dispatch(
                                                storeMedia(
                                                {
                                                    img: img,
                                                    uploadType: "aadharFront",
                                                    isRes: false,
                                                },
                                                (res) => {
                                                    setUploadStatus(true);
                                                    setDisplayName((prev) => [
                                                    { name: img?.name },
                                                    ]);
                                                    setImageLoader(false);
                                                    if (res?.url) {
                                                    console.log("opt", res);
                                                    tempArray.push(
                                                        res?.data?.Location
                                                    );
                                                    setFieldValue(
                                                        "docUrl",
                                                        res?.url,
                                                        true
                                                    );
                                                    // setFieldValue('docs', tempArray, true);
                                                    //for now  only one supported
                                                    setFieldValue(
                                                        "docs",
                                                        [res?.data?.Location],
                                                        true
                                                    );
                                                    }
                                                }
                                                )
                                            );
                                            }
                                        }}
                                        />
                                    </div>
                                    )}
                                    <div
                                    style={{
                                        margin: "0px -16px 2px -614px",
                                        color: "red",
                                    }}
                                    >
                                    {errors.docUrl && touched.docUrl ? (
                                        <div>*{errors.docUrl}</div>
                                    ) : null}
                                    </div>
                                </Button>
                                ) : (
                                <></>
                                )}
                                <div className="selected-img">
                                {uploadStatus ? (
                                    displayName?.map((d) => {
                                    return (
                                        <div className="row" style={{marginTop: "10px",marginLeft: "-40px",justifyContent:"space-between"}}>
                                        <div className="col-9">
                                            <p
                                            style={{
                                                color: "black",
                                                cursor: "pointer",
                                                marginRight: "10px",
                                            }}
                                            onClick={() => {
                                                window.open(d.link);
                                            }}
                                            >
                                            {d.name.slice(0,15)}
                                            </p>
                                        </div>
                                        <div
                                            className="col-3"
                                            onClick={() => {
                                                setUploadStatus(false);
                                            }}
                                        >
                                            Change
                                        </div>
                                        </div>
                                    );
                                    })
                                ) : (
                                    <></>
                          )}
                        </div>
                      </div>
                    </FormGroup>
                    <FormGroup
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Button
                        type="submit"
                        style={{ width: "100%" }}
                        className="generateOtp text3 Medium btn btn-secondary"
                      >
                        Submit
                      </Button>
                    </FormGroup>
                  </div>
                </Form>
              )}
            </Formik>
                </div>)
            }
                   
                </div>
            </div>
            {imageModal ? (
          <ImageModal
            toggle={toggleImageModal}
            imageModal={imageModal}
            setImageModal={setImageModal}
            image={imageUrl.split('?')[0]}
           
          />
        ) : null}
            </div> )
}
export default DocumentItems;




